/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { EnvironmentService } from './app/services/environment.service';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
];

if (environment.production) {
  enableProdMode();
}

async function bootstrap() {
  const envService = new EnvironmentService(null,null);
  const env = await envService.fetchEnvironment();

  if (env?.auth0) {
    environment.auth0 = env.auth0;
  }
  else {
    console.log('Unable to fetch auth settings');
  }

  // Angular 21+ bootstraps zoneless by default; keep zone.js-driven change detection.
  platformBrowserDynamic(providers).bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch(err => console.log(err));

}

bootstrap();